/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* GCP project configuration. Applicable if `cloudProvider` is set to `GCP`. 
*/
export class GcpSourceAccountAttributes {
  'serviceAccount': string;
  /**
  * Cloud-provider-assigned ID of the GCP project\'s parent organization.
  */
  'organizationId'?: string;
  /**
  * Cloud-provider-assigned ID of the GCP project\'s parent folder.
  */
  'folderId'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "serviceAccount",
      "baseName": "serviceAccount",
      "type": "string",
      "format": ""
    },
    {
      "name": "organizationId",
      "baseName": "organizationId",
      "type": "string",
      "format": ""
    },
    {
      "name": "folderId",
      "baseName": "folderId",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return GcpSourceAccountAttributes.attributeTypeMap;
  }

  public constructor() {
  }
}

